// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2w5pz","noInteraction":"EventWrapper_noInteraction__eMfSz","pointerPassthrough":"EventWrapper_pointerPassthrough__3wYaK"};